<template>
  <div>
    <h2>错误页面</h2>
    <p>{{ this.$route.query.msg }}</p>
    <a @click="this.$router.push('/')">返回首页</a>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage'
}
</script>

<style scoped>

</style>
